<template>
	<swiper ref="swiper" parallax :spaceBetween="30" :fadeEffect="{
		crossFade: true
	}" :navigation="false" :pagination="{
      clickable: true,
    }" :modules="modules" class="mySwiper" loop :autoplay="{
		delay:10000,
		pauseOnMouseEnter:true
	}" :speed="3000" @swiper="initSwiper">
		<swiper-slide style="background-color: #0a0e1d;"><video style="width: 67%;margin-left: 15%;" @play="playVideo"
				@pause="pauseVideo" @ended="endedVideo"
				src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E5%A4%A7%E7%94%B0/%E5%8D%83%E5%B9%BF%E9%81%A5%E6%84%9F%2BAI.mp4"
				controls autoplay muted></video></swiper-slide>
				<!-- poster="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%AC/%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2%EF%BC%92.jpg" -->
		<swiper-slide>
			<div class="cent-bg flexCol alit justc " style="">
				<div class="commpany-name textbg">让农民成为受人尊敬的职业</div>
			</div>
			</swiper-slide>
		<!-- <swiper-slide>
			<h2 class="slide-title" data-swiper-parallax="-1000">阿迪斯发手动阀撒旦发射点发射点发士大夫啊手动阀手动阀</h2>
			<p class="slide-desc" data-swiper-parallax="-2000">阿迪斯发手动阀撒旦发射点发射点发士大夫啊手动阀手动阀</p>
		</swiper-slide> -->
		<swiper-slide>
			<div class="cent-bg2 flexCol alit justc " style="">
				<div class="commpany-name textbg">天下富足 禾下乘凉</div>
			</div>
		</swiper-slide>
		<!-- <swiper-slide><img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/swiper/1745218919341.jpg" /></swiper-slide> -->
	</swiper>
</template>
<script>
	// Import Swiper Vue.js components
	import {
		Swiper,
		SwiperSlide
	} from 'swiper/vue';

	// Import Swiper styles
	import 'swiper/css';

	import 'swiper/css/effect-fade';
	import 'swiper/css/navigation';
	import 'swiper/css/pagination';

	import './style.css';

	// import required modules
	import {
		EffectFade,
		Navigation,
		Pagination,
		EffectCoverflow,
		Parallax,
		Autoplay
	} from 'swiper/modules';

	export default {
		components: {
			Swiper,
			SwiperSlide,
		},
		setup() {
			return {
				modules: [EffectFade, EffectCoverflow, Parallax, Autoplay],
			};
		
		},
		data(){
			return{
				swiperInstance: null
			}
		},
		created() {
			// this.pauseVideo()
		},
		methods: {
			initSwiper(swiper){
				this.swiperInstance = swiper
			},
			// 视频播放
			playVideo() {
				this.swiperInstance.autoplay.stop()
			},
			// 视频暂停
			pauseVideo() {
				this.swiperInstance.autoplay.start()
			},
			// 视频停止
			endedVideo() {
				this.swiperInstance.autoplay.start()
			}
		}
	};
</script>
<style scoped>
	.textbg{
		width: auto;
		background-color: rgba(0, 0, 0, 0.2);
		border-radius: 10px;
		padding: 20px;
	}
	.cent-bg2{
		width: 100%;
		height: 100%;
		background-image: url('https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E9%A6%96%E9%A1%B5%E8%BD%AE%E6%92%AD.jpg');
		background-size: 100% 100%;
	}
	.cent-bg{
		width: 100%;
		height: 100%;
		background-image: url('https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E9%A6%96%E9%A1%B5%E8%BD%AE%E6%92%AD1.jpg');
		background-size: 100% 100%;
	}
	img {
		width: 100%;
		height: 100%;
	}
</style>